__turbopack_context__.v({
  "container": "CumulativeDonationsSkeleton-module-scss-module__Bou90q__container",
  "graph": "CumulativeDonationsSkeleton-module-scss-module__Bou90q__graph",
  "shimmer": "CumulativeDonationsSkeleton-module-scss-module__Bou90q__shimmer",
});
